import React from 'react';

import '../../assets/css/Sketches.css';
import SketchGrid from '../SketchGrid';
import sketchList from '../SketchList';
import CompactSideBar from '../CompactSidebar';

export default class Sketches extends React.Component {
  constructor(props) {
    super(props);
    this.state = { sketches: sketchList };
  };

  render() {
    return (
      <>
        <CompactSideBar />
        <div className="Sketch">
          <SketchGrid sketches={this.state.sketches} />
        </div>
      </>
    );
  };
}